var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 9,
    viewBox: "0 0 42 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.6005L0.436454 7.11315C1.426 8.00055 2.33824 8.4132 3.66195 8.4132C4.98566 8.4132 5.93679 7.67565 5.93679 6.6753V6.65055C5.93679 5.7249 5.43554 5.18805 3.39212 4.788C1.23392 4.3632 0.359623 3.6504 0.359623 2.32515V2.3004C0.359623 0.99945 1.58058 0 3.25188 0C4.56263 0 5.42351 0.34965 6.33668 1.06245L5.91272 1.57455C5.06481 0.86175 4.21597 0.58725 3.22643 0.58725C1.90272 0.58725 1.02842 1.3248 1.02842 2.23785V2.2626C1.02842 3.18825 1.51671 3.75075 3.65038 4.1751C5.73175 4.5873 6.60605 5.31225 6.60605 6.58755V6.6123C6.60605 8.0253 5.35963 9 3.62493 9C2.18597 9 1.08026 8.5374 0.000925671 7.6005H0Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2792 5.02943V0.741375H11.8239C13.4433 0.741375 14.5481 1.46633 14.5481 2.85368V2.87843C14.5481 4.17847 13.4169 5.02853 11.7466 5.02853H10.2618V5.62793H11.7086C13.585 5.62793 15.2174 4.67753 15.2174 2.84017V2.81543C15.2174 1.12792 13.8548 0.140625 11.8757 0.140625H8.61133V8.89178H9.27966V5.62883",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9417 4.67887V0.741375H29.0126C30.6451 0.741375 31.5953 1.47892 31.5953 2.65388V2.67863C31.5953 3.94132 30.4766 4.67887 28.9733 4.67887H26.929V5.26613H28.8835L31.7494 8.89087H32.5973L29.6287 5.15273C31.1449 4.95293 32.2631 4.11503 32.2631 2.65298V2.62823C32.2631 2.00318 32.0063 1.41593 31.5823 1.00328C31.0422 0.477675 30.1563 0.140625 29.0506 0.140625H25.2725V8.89178H25.9408V5.26702",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6034 4.42777L34.1604 0.140625H34.9574L38.0283 4.00297L41.0867 0.140625H41.8712L38.4143 4.42868L42.0004 8.89178H41.2033L38.0033 4.85438L34.8158 8.89178H34.0312L37.6034 4.42868V4.42777Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2476 1.4274L22.7059 8.26065H15.7805L19.2476 1.4274ZM19.2486 0L14.7373 8.89155H23.7487L19.2486 0Z",
    fill: "url(#paint0_linear_26032_51326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26032_51326",
    x1: 15.3737,
    y1: 9.4689,
    x2: 21.9566,
    y2: 3.75769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F54DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF83B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2276cd5fca95f21c5b6c80f8abb68ec4.svg";
export { ForwardRef as ReactComponent };